import axios from "axios";
import React, { useEffect, useState } from "react";
import { base_url } from "../../../utils/AxiosConfig";
import { format, differenceInMinutes } from "date-fns";
import { toast } from "react-toastify";
import SnackbarNotification from "../../../utils/SnackbarNotification";

const ViewEvaluationpopUp = ({ popUpData, date }) => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const cmpCode = companyCode;

  const [postData, setPostData] = useState([]);

  const [attendanceDetail, setAttendanceDetail] = useState([]);

  const [pairedPunches, setPairedPunches] = useState([]);

  const [error, setError] = useState(false);

  const [totalMinutes, setTotalMinutes] = useState(0); // State for total minutes
  const [totalHours, setTotalHours] = useState("0.00"); // State for total hours
  const [totalMinutesDifference, setTotalMinutesDifference] = useState(0); // State for total minutes
  const [totalHoursDifference, setTotalHoursDifference] = useState("0.00"); // State for total hours

  // Utility function to format date and time
  const formatDateAndTime = (punchTime) => {
    const dateObj = new Date(punchTime);
    const formattedDate = format(dateObj, "MM/dd/yyyy"); // Format date
    const formattedTime = format(dateObj, "hh:mm a"); // Format time
    return { formattedDate, formattedTime };
  };

  const handleTimeChange = (index, newTime) => {
    console.log("newTimeChange", newTime);
    const newPunches = [...attendanceDetail]; // Create a copy of the current attendanceDetail
    const currentPunch = newPunches[index];

    // Convert the existing punch_time to a Date object
    const punchDate = new Date(currentPunch.punch_time);

    console.log("punchDate", punchDate);

    // Split the new time input (HH:MM) into hours and minutes
    // const [hours, minutes] = newTime.split(':').map(Number);
    const [hours, minutes] = newTime.split(":");

    // Set the new hours and minutes
    punchDate.setHours(hours);
    punchDate.setMinutes(minutes);

    console.log("punchDateChange", punchDate);
    // console.log('punchDateChangeISO', punchDate.toISOString());

    // Update the punch_time in the copy of the attendanceDetail
    // newPunches[index].punch_time = punchDate.toISOString();
    newPunches[index].punch_time = punchDate;

    console.log("newPunches", newPunches);

    // Update state with the new array
    setAttendanceDetail(newPunches);
  };

  const addNewRow = () => {
    const newPunches = [...attendanceDetail]; // Copy the existing punchData array

    const newId =
      newPunches.length > 0 ? newPunches[newPunches.length - 1].id + 1 : 1; // Generate new ID
    const currentTime = new Date(date); // Get current date and time
    const empCode = newPunches.length > 0 ? newPunches[0].emp_code : "null"; // Use the same emp_code

      const lastEntry = attendanceDetail[attendanceDetail.length - 1];

    const newRow = {
      id: newId,
      emp_code: empCode,
      punch_time: currentTime.toISOString(), // Current date and time in ISO format
      // type: "IN",
      type: !lastEntry ? "IN" : lastEntry.type === "IN" ? "OUT" : "IN",
      jobid: "-",
      shift: "-",
      deviceid: null,
      latitude: null,
      longitude: null,
    };

    newPunches.push(newRow); // Add the new row to the array
    // Update state with the new array
    setAttendanceDetail(newPunches);
  };

  // Function to update punch_time with the new time
  const updatePunchTime = (originalTime, newTime) => {
    const date = new Date(originalTime);
    const [hours, minutes] = newTime.split(":");
    date.setHours(hours);
    date.setMinutes(minutes);
    return date.toISOString();
  };

  // Handler for type change
  const handleTypeChange = (index, newType) => {
    const updatedDetail = attendanceDetail.map((punch, idx) => {
      if (idx === index) {
        return { ...punch, type: newType };
      }
      return punch;
    });
    setAttendanceDetail(updatedDetail);
  };

  // Handler for deleting a row
  const handleDeleteRow = (index) => {
    const updatedDetail = attendanceDetail.filter((_, idx) => idx !== index);
    setAttendanceDetail(updatedDetail);
  };

  // Function to format punch_time for the input
  // const formatTimeForInput = (punch_time) => {
  //   const date = new Date(punch_time); // Create a Date object from the punch_time
  //   return format(date, 'HH:mm'); // Format it as HH:mm
  // };

  // Function to format punch_time for the input
  const formatTimeForInputA = (punch_time) => {
    console.log("punch_time", punch_time);
    const date = new Date(punch_time); // Create a Date object from the punch_time

    console.log("dateFormat", date);

    // Adjust for local time by using the local offset
    const localTime = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000,
    );

    console.log("localTime", localTime);

    return format(localTime, "HH:mm"); // Format it as HH:mm
  };

  const formatTimeForInput = (punch_time) => {
    //  console.log('punch_time',punch_time)

    const date = new Date(punch_time); // Create a Date object from the punch_time

    //  console.log('dateFormat',date)
    return format(date, "HH:mm"); // Format it as HH:mm (24-hour format)
  };

  // Function to calculate total time from API data
//   const calculateTotalTime = (punches) => {
//     let totalMinutes = 0;
//     let totalHours = 0;
//     let lastIn = null;
// console.log('punches:',punches)
//     punches.forEach((punch) => {
//       if (punch.type === "IN") {
//         lastIn = punch;
//       } else if (punch.type === "OUT" && lastIn) {
//         // Calculate the time difference in minutes
//         const minutes = differenceInMinutes(
//           new Date(punch.punch_time),
//           new Date(lastIn.punch_time),
//         );
//         if (minutes > 0) {
//           totalMinutes += minutes;
//           lastIn = null; // Reset lastIn after pairing
//         }
//       }
//     });

//     totalHours = (totalMinutes / 60).toFixed(2); // Convert total minutes to hours
//     return {
//       totalMinutes,
//       totalHours,
//     };
//   };

const calculateTotalTime = (punches) => {
  if (!punches || punches.length === 0) {
    return { totalMinutes: 0, totalHours: "0.00" };
  }

  // 🔥 Sort by punch_time
  const sortedPunches = [...punches].sort(
    (a, b) => new Date(a.punch_time) - new Date(b.punch_time)
  );

  let totalMinutes = 0;
  let lastIn = null;

  sortedPunches.forEach((punch) => {
    if (punch.type === "IN") {
      lastIn = punch;
    } 
    else if (punch.type === "OUT" && lastIn) {
      const inTime = new Date(lastIn.punch_time);
      const outTime = new Date(punch.punch_time);

      const minutes = differenceInMinutes(outTime, inTime);

      if (minutes > 0) {
        totalMinutes += minutes;
      }

      lastIn = null;
    }
  });

  return {
    totalMinutes,
    totalHours: (totalMinutes / 60).toFixed(2),
  };
};

  // sendAPi
  const sendAttendanceApi = async () => {
    try {
      const postDataToSend = JSON.stringify(postData);

      const response = await axios.post(
        `${base_url}/api/PersonalInfAttEvaluation`,
        postDataToSend,
        {
          headers: {
            "Content-Type": "application/json", // Set the content type to application/json
          },
        },
      );

      console.log("Response data:", response.data); // Log the response data
      if (response.status === 200) {
        // toast.success('Attendance Updated successfully')
        showSnackbar("success", "Attendance Updated successfully");
        fetchAttendanceDetail();
      }
    } catch (error) {
      console.error(
        "Error sending attendance data:",
        error.response ? error.response.data : error.message,
      ); // Log any errors that occur
      showSnackbar("error", "Error sending attendance data.");
    }
  };

  // Function to convert rows to desired format
  const convertRowsToPostData = (attendanceDetail, cmpCode, empId) => {
    return attendanceDetail.map((row) => {
      const punchTime = format(new Date(row.punch_time), "yyyy-MM-dd HH:mm"); // Format the date
      return {
        CmpCode: cmpCode,
        EmpId: empId,
        Type: row.type,
        PunchTime: punchTime,
        JobId: "-",
        Shift: "-",
      };
    });
  };

  useEffect(() => {
    if (attendanceDetail && popUpData) {
      const postData = convertRowsToPostData(
        attendanceDetail,
        cmpCode,
        popUpData.EmpId,
      );

      setPostData(postData);
    }
  }, [attendanceDetail, popUpData]);

  const fetchAttendanceDetail = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/CRMAttendanceDetail/${cmpCode}/${popUpData.EmpId}/${date}`,
      );

      if (response.status === 200 && response.data) {
        setAttendanceDetail(response.data);

        console.log("settingAttDetailEffect:",response.data);

        // Call processPunches with the fetched data
        // const processedPunches = processPunches(response.data);
        // setPairedPunches(processedPunches); // Set the processed punches for rendering

        // Calculate total time
        const { totalMinutes, totalHours } = calculateTotalTime(response.data);
        console.log(`Total Time1: ${totalMinutes} minutes, ${totalHours} hours`);

        // Update the total minutes and hours in state
        setTotalMinutesDifference(totalMinutes);
        setTotalHoursDifference(totalHours);
        // setTotalMinutes(totalMinutes);
        // setTotalHours(totalHours);
        console.log(`Total Time: ${totalMinutes} minutes, ${totalHours} hours`);
      } else {
        setError(true);
      }
    } catch (error) {
      console.log("fetchAttendanceDetailError", error);
      setError(true);
    }
  };

  // Calculate the total minutes and hours between IN and OUT rows
  const calculateTotalTimeB = () => {
    let totalMinutes = 0;

    for (let i = 0; i < postData.length - 1; i++) {
      if (postData[i].Type === "IN" && postData[i + 1].Type === "OUT") {
        // Parse the PunchTime strings into Date objects
        const inPunchTime = new Date(postData[i].PunchTime);
        const outPunchTime = new Date(postData[i + 1].PunchTime);

        // Calculate the difference in minutes
        totalMinutes += differenceInMinutes(outPunchTime, inPunchTime);
      }
    }

    // Update the total minutes and hours
    setTotalMinutes(totalMinutes);
    setTotalHours((totalMinutes / 60).toFixed(2)); // Round to 2 decimal places for hours
  };

  useEffect(() => {
    if (popUpData && date) {
      fetchAttendanceDetail();
    }
  }, [popUpData, date]);

  useEffect(() => {
    if (postData.length > 0) {
      calculateTotalTimeB();
    }
  }, [postData]);

  console.log("attendanceDetail", attendanceDetail);

  console.log("postData", postData);

  // console.log(totalMinutes,totalHours)

  // console.log('pairedPunches',pairedPunches)

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const showSnackbar = (severity, message) => {
    setSnackbar({ open: true, severity, message });
  };

  const handleClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  return (
    <div>
      <div
        className="modal fade"
        id="staticBackdropnew"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content rounded-xl shadow-2xl overflow-hidden border-0">
            {/* Header */}
            <div className="modal-header bg-gradient-to-r from-blue-600 to-blue-800 text-white p-4">
              <div className="flex justify-left items-center">
                <div className="w-1 h-6 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
                <h1 className="modal-title text-md font-bold tracking-wide">
                  VIEW & EDIT ATTENDANCE
                </h1>
              </div>
              <button
                type="button"
                className="text-white hover:text-gray-200 transition-colors"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="modal-body p-6 bg-gray-50">
              {/* Summary Card */}
              <div className="bg-white rounded-lg shadow-sm p-5 mb-6 border border-gray-200">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                  <div>
                    <span className="text-gray-500 font-medium">EmpID:</span>
                    <p className="font-semibold text-gray-900">
                      {popUpData?.EmpId || "—"}
                    </p>
                  </div>
                  <div>
                    <span className="text-gray-500 font-medium">Name:</span>
                    <p className="font-semibold text-gray-900">
                      {popUpData?.Name || "—"}
                    </p>
                  </div>
                  <div>
                    <span className="text-gray-500 font-medium">
                      Designation:
                    </span>
                    <p className="font-semibold text-gray-900">
                      {popUpData?.JobTitle || "—"}
                    </p>
                  </div>
                  <div>
                    <span className="text-gray-500 font-medium">Date:</span>
                    <p className="font-semibold text-gray-900">{date || "—"}</p>
                  </div>
                  <div>
                    <span className="text-gray-500 font-medium">
                      Total Minutes:
                    </span>
                    <p className="font-semibold text-gray-900">
                      {/* {totalMinutes || "0"} */}
                      {totalMinutesDifference || '0'}
                    </p>
                  </div>
                  <div>
                    <span className="text-gray-500 font-medium">
                      Total Hours:
                    </span>
                    <p className="font-semibold text-gray-900">
                      {totalHoursDifference || "0"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Attendance Details Table */}
              <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200">
                <div className="max-h-[320px] overflow-y-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-blue-500 sticky top-0 ">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-white uppercase tracking-wider">
                          Reg Time
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-white uppercase tracking-wider">
                          Type
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-semibold text-white uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {attendanceDetail.length > 0 ? (
                        attendanceDetail.map((punch, index) => {
                          const { formattedDate, formattedTime } =
                            formatDateAndTime(punch.punch_time);

                          return (
                            <tr
                              key={index}
                              className="hover:bg-gray-50 transition-colors"
                            >
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                <div className="flex items-center gap-3">
                                  <span className="font-medium">
                                    {formattedTime}
                                  </span>
                                  <input
                                    type="time"
                                    className="border border-gray-300 rounded px-2 py-1 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                    value={formatTimeForInput(punch.punch_time)}
                                    onChange={(e) =>
                                      handleTimeChange(index, e.target.value)
                                    }
                                  />
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm">
                                <select
                                  value={punch.type}
                                  onChange={(e) =>
                                    handleTypeChange(index, e.target.value)
                                  }
                                  className="border border-gray-300 rounded px-3 py-1 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white"
                                >
                                  <option value="IN">IN</option>
                                  <option value="OUT">OUT</option>
                                </select>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                <div className="flex items-center gap-3">
                                  <button
                                    onClick={() => handleDeleteRow(index)}
                                    className="text-white bg-red-600 hover:bg-red-800 font-medium transition-colors px-2 py-1 rounded"
                                  >
                                    Delete
                                  </button>

                                  {punch.latitude && punch.longitude && (
                                    <button
                                      onClick={() =>
                                        window.open(
                                          `https://www.google.com/maps?q=${punch.latitude},${punch.longitude}`,
                                          "_blank",
                                        )
                                      }
                                      className="inline-flex items-center gap-1 px-3 py-1 bg-blue-600 text-white text-xs rounded-md hover:bg-blue-700 transition-colors shadow-sm"
                                    >
                                      <svg
                                        className="w-4 h-4"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                        />
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                        />
                                      </svg>
                                      Map
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan="3"
                            className="px-6 py-10 text-center text-gray-500"
                          >
                            No attendance records found for this date.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {error && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg">
                  {error}
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="modal-footer bg-gray-50 px-6 py-4 flex justify-between items-center border-t">
              <button
                type="button"
                className="px-5 py-2.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-sm flex items-center gap-2"
                onClick={() => addNewRow()}
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4v16m8-8H4"
                  />
                </svg>
                Add Row
              </button>

              {postData && postData.length > 0 && (
                <button
                  type="button"
                  className="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-md font-medium"
                  onClick={() => sendAttendanceApi()}
                >
                  Save Changes
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <SnackbarNotification
        open={snackbar.open}
        severity={snackbar.severity}
        message={snackbar.message}
        onClose={handleClose}
      />
    </div>
  );
  // return (
  //   <div>
  //     <div>
  //       <div
  //         class="modal fade"
  //         id="staticBackdropnew"
  //         data-bs-backdrop="static"
  //         data-bs-keyboard="false"
  //         tabindex="-1"
  //         aria-labelledby="staticBackdropLabel"
  //         aria-hidden="true"
  //       >
  //         <div class="modal-dialog modal-lg">
  //           <div class="modal-content">
  //             <div class="modal-header">
  //               <h1
  //                 class="modal-title  text-secondary fs-small"
  //                 id="staticBackdropLabel"
  //               >
  //                 View Attendance
  //               </h1>
  //               <button
  //                 type="button"
  //                 class="btn-close"
  //                 data-bs-dismiss="modal"
  //                 aria-label="Close"
  //               ></button>
  //             </div>
  //             <div class="modal-body">
  //               <div className="container-fluid">
  //                 <table class="table border">
  //                   <tbody>
  //                     <tr>
  //                       <td>EmpID</td>
  //                       <td>{popUpData?.EmpId}</td>
  //                     </tr>
  //                     <tr>
  //                       <td>Name</td>
  //                       <td>{popUpData?.Name}</td>
  //                     </tr>
  //                     <tr>
  //                       <td>Designation</td>
  //                       <td>{popUpData?.JobTitle}</td>
  //                     </tr>
  //                     <tr>
  //                       <td>Date</td>
  //                       <td>{date}</td>
  //                     </tr>
  //                     <tr>
  //                       <td>Total Minutes</td>
  //                       <td>{totalMinutes}</td>
  //                     </tr>
  //                     <tr>
  //                       <td>Total Hours</td>
  //                       <td>{totalHours}</td>
  //                     </tr>
  //                   </tbody>
  //                 </table>
  //                 <div
  //                   className="container scroll"
  //                   style={{ maxHeight: "250px" }}
  //                 >
  //                   <table class="table">
  //                     <tbody>
  //                       <tr className="">
  //                         {/* <td>Date</td> */}
  //                         <td>Reg Time </td>
  //                         <td>Type</td>
  //                         <td>Actions</td>
  //                         {/* <td>Total Minutes</td>
  //                         <td>Total Hours</td> */}
  //                       </tr>

  //                       {attendanceDetail.length > 0 ? (
  //                         attendanceDetail.map((punch, index) => {
  //                           // Call the format function for punch_time
  //                           const { formattedDate, formattedTime } =
  //                             formatDateAndTime(punch.punch_time);
  //                           console.log("punch", punch);
  //                           // console.log('formattedTimeFromLoop',formattedTime)

  //                           return (
  //                             <tr key={index}>
  //                               {/* <td>{formattedDate}</td>   */}
  //                               <td>
  //                                 <div className="d-flex justify-content-between align-items-center">
  //                                   {/* <div>{format(row.reqtime, 'dd-MMM-yyyy h:mm a')}</div> */}
  //                                   {/* <div>{formatTimeForInput(punch.punch_time)}</div> */}
  //                                   <div>{formattedTime}</div>
  //                                   <input
  //                                     type="time"
  //                                     className="form-control ms-3"
  //                                     value={formatTimeForInput(
  //                                       punch.punch_time,
  //                                     )}
  //                                     // value={formattedTime}
  //                                     onChange={(e) =>
  //                                       handleTimeChange(index, e.target.value)
  //                                     }
  //                                     style={{ width: "120px" }} // Adjust width to fit within the row
  //                                   />
  //                                 </div>

  //                                 {/* {formattedTime} */}
  //                               </td>
  //                               <td>
  //                                 <select
  //                                   value={punch.type}
  //                                   onChange={(e) =>
  //                                     handleTypeChange(index, e.target.value)
  //                                   } // Updated handler for type change
  //                                 >
  //                                   <option defaultValue={punch.type} />
  //                                   <option value="IN">IN</option>
  //                                   <option value="OUT">OUT</option>
  //                                 </select>
  //                                 {/* {punch.type} */}
  //                               </td>

  //                               <td>
  //                                 <button
  //                                   class="btn red-btn"
  //                                   onClick={() => handleDeleteRow(index)}
  //                                 >
  //                                   Delete
  //                                 </button>
  //                               </td>

  //                               <td>
  //                                 {punch.latitude && punch.longitude && (
  //                                   <button
  //                                     onClick={() =>
  //                                       window.open(
  //                                         `https://www.google.com/maps?q=${punch.latitude},${punch.longitude}`,
  //                                         "_blank",
  //                                       )
  //                                     }
  //                                     className="inline-flex items-center gap-1 px-2 py-1 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 transition"
  //                                   >
  //                                     <svg
  //                                       className="w-3 h-3"
  //                                       fill="currentColor"
  //                                       viewBox="0 0 24 24"
  //                                     >
  //                                       <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z" />
  //                                     </svg>
  //                                     View on Map
  //                                   </button>
  //                                 )}
  //                               </td>

  //                               {/* <td>{totalMinutes}</td>
  //                                 <td>{totalHours}</td> */}
  //                             </tr>
  //                           );
  //                         })
  //                       ) : (
  //                         <tr>
  //                           <td colSpan="5">No Data found.</td>
  //                         </tr>
  //                       )}
  //                     </tbody>
  //                   </table>

  //                   {error && <p>Error fetching attendance details</p>}
  //                 </div>
  //               </div>
  //             </div>

  //             <div class="modal-footer">
  //               <button
  //                 type="button"
  //                 class="btn dash-btn"
  //                 onClick={() => addNewRow()}
  //               >
  //                 Add Row
  //               </button>

  //               {postData && postData.length > 0 && (
  //                 <button
  //                   type="button"
  //                   class="btn dash-btn"
  //                   onClick={() => sendAttendanceApi()}
  //                 >
  //                   Save
  //                 </button>
  //               )}
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //     <SnackbarNotification
  //       open={snackbar.open}
  //       severity={snackbar.severity}
  //       message={snackbar.message}
  //       onClose={handleClose}
  //     />
  //   </div>
  // );
};

export default ViewEvaluationpopUp;
